import React, { useEffect, useState } from "react";
import * as _ from "lodash"
import { Table } from "react-bootstrap";
import moment from "moment";

// constants
import LoadingSpinner from "../../../components/LoadingSpinner";
import { getCommentsWithPagination } from "../../../services/facebook/comment";
import { Form } from "react-bootstrap";
import { readShopPagesRaw } from "../../../helpers/shopPages";
const limit = 100;
function PostFacebookComment({ fbCommentSelect, setFbCommentSelect, liveData, onTab, setLoading, loading }) {
    const [listData, setListData] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [defaultMsg, setDefaultMsg] = useState("ບໍ່ພົບຂໍ້ມູນ...ກະລຸນາລອງໃຫມ່ຫລັງຈາກ 10ນາທີ");

    // useEffect Hooks
    useEffect(() => {
        if(onTab === 'fbComment') {
            // get data from facebook api
            setTimeout(() => {
                const shopPageCookie = readShopPagesRaw();
                const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];
                let _pageIndex = _.findIndex(assignedPageList, {
                    id: liveData.page,
                });
                fetchFbCommentOnFeed(liveData, assignedPageList[_pageIndex]);
            }, 100)
        }
    }, [onTab]);

    // Fetch the first page of comments with a limit of 50
    async function fetchFbCommentOnFeed(req, page) {
        // console.log("req", req);
        try {
            const accessToken = page?.access_token || req?.pageAccessToken;
            if(loading) return;
            setLoading(true);
            let filter = {
                pageId:req?.page, 
                postId: req?.fbFeedId, 
                accessToken: accessToken, //page?.access_token, //req?.pageAccessToken, 
                limit, 
            }
            if(!accessToken) {//if(!page?.access_token) {
                setDefaultMsg("ບໍ່ພົບຂໍ້ມູນ...ກະລຸນາລອງໃຫມ່ຫລັງຈາກເຊຶ່ອມຕໍ່facebook");
                setLoading(false);
                return;
            };
            const data = await getCommentsWithPagination(filter);
            setLoading(false);
            if (data === "INVALID_DATA_REQUEST") {
                console.log("Invalid data request");
                setListData([]);
                return;
            }    
            if(data){
                setListData(data);
            }else {
                setListData([]);
            }
        } catch (error) {
            console.log(error);
        }
    };
    
    const getSelectComment = async (idx) => {
        const checkId = fbCommentSelect.find((item) => item?.id === idx?.id);
        if (checkId) {
            const updatedDataSelect = fbCommentSelect.filter((item) => item?.id !== idx?.id);
            setFbCommentSelect(updatedDataSelect);
        } else {
            const updatedDataSelect = [...fbCommentSelect, idx];
            setFbCommentSelect(updatedDataSelect);
        }
    };

    function handleSelectAll() {
        if (isSelectAll) {
            setIsSelectAll(false);
            setFbCommentSelect([]);
        } else {
            setIsSelectAll(true);
            setFbCommentSelect(listData);
        }
    }

    return (
        <>
            {loading ? <LoadingSpinner/>: (
                <div>
                    {
                        listData.length <= 0 ? (
                            <div className="py-2">
                                <p style={{ fontSize: 20, alignItems: "center", justifyContent: "center"}}>[{defaultMsg}]</p>
                            </div>
                        ):(
                            <>
                                <div>
                                    <Table responsive className="staff-table-list borderless table-hover">
                                        <thead style={{ background: "#F1F1F1" }}>
                                            <tr>
                                                {/* <th style={{ borderBottom: "none" }}>ລຳດັບ</th> */}
                                                <th style={{ borderBottom: "none" }}>
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        id="ລຳດັບ"
                                                        label="ລຳດັບ"
                                                        checked={isSelectAll}
                                                        onClick={() => handleSelectAll()}
                                                    />
                                                </th>
                                                <th style={{ borderBottom: "none" }}>ຊື່ລູກຄ້າ</th>
                                                <th style={{ borderBottom: "none" }}>ຄອມເມັ້ນ</th>
                                                <th style={{ borderBottom: "none", textAlign: 'center' }}>ສະຖານະ</th>
                                                <th style={{ borderBottom: "none" }}>ວັນທີ,ເດືອນ,ປີ</th>
                                                {/* <th style={{ borderBottom: "none" }}>ຈັດການ</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listData?.map((comment, index) => {
                                                let selected = fbCommentSelect.filter(
                                                    (id) => id?.id === comment?.id
                                                );
                                                return (
                                                <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                                                    {/* <td>{index + 1}</td> */}
                                                    {isSelectAll ? (
                                                        <td>
                                                        <Form.Check type="checkbox"
                                                            label={index + 1}
                                                            checked={true} disabled />
                                                        </td>
                                                    ) : (
                                                        <td>
                                                        <Form.Check
                                                            checked={selected.length > 0}
                                                            onChange={() => getSelectComment(comment)}
                                                            type="checkbox"
                                                            id={index + 1}
                                                            label={index + 1}
                                                        />
                                                        </td>
                                                    )}
                                                    <td>
                                                        <div style={{ fontSize: 12, display: 'flex', justifyContent: 'start', alignItems: 'start' }}>
                                                            {comment?.from?.picture ? (
                                                                <img className="mr-2" src={comment?.from?.picture?.data?.url} alt="fb"
                                                                    style={{ width: 30, height: 30, borderRadius: 50 }}
                                                                />
                                                            ) : (
                                                            <img className="mr-2" src="https://img.freepik.com/premium-vector/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-vector-illustration_561158-3383.jpg" alt="fb"
                                                                style={{ width: 30, height: 30, borderRadius: 50 }}
                                                            />
                                                            )}
                                                            {/* <div style={{ padding: 5, borderRadius: 10, background: '#f2f2f2', }}> */}
                                                                <p style={{ fontSize: 14, fontWeight: 'bold' }}>{comment?.from?.name ?? comment?.name}</p>
                                                            {/* </div> */}

                                                        </div>
                                                    </td>
                                                    <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{comment?.message ?? ""}</td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <span style={{
                                                            padding: 10,
                                                            borderRadius: 8, fontSize: 10,
                                                            border: '1px solid ' + (comment?.can_reply_privately? "red" : "green"),
                                                            color: comment?.can_reply_privately? "red" : "green"
                                                        }}>
                                                            {comment?.can_reply_privately? "ຍັງບໍ່ໄດ້ສ້າງອໍເດີ້" : "ມີການຕອບກັບ ອໍເດີ້ອາດສ້າງສໍາເລັດ" }
                                                        </span>
                                                    </td>
                                                    <td>{moment(comment?.created_time).format('DD/MM/YYYY HH:mm A')}</td>
                                                </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </>
                        )
                    }
                </div >
            )}
        </>
    );
}

export default PostFacebookComment;